import * as pdfjsLib from 'pdfjs-dist';

// Configure PDF.js worker
if (typeof globalThis.window !== 'undefined') {
  pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
}

export { pdfjsLib };
